import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { HttpHeaders } from '@angular/common/http';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SurveyStatusService {

  idEmpresa: string;
  idUsuario: string;
  infoUsuario: any;
  idInstituto: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    // console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
    this.infoUsuario = this.authService.getInfoUsuario();
  }

  getInstituto(){
    this.obtienInfo();
    return this.idInstituto;
  }

  getInfoUsuario(){
    return this.infoUsuario;
  }
  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }
  getInfoEmpresa(idEmpresa:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + idEmpresa);
  }

  getUsuarios(productoId,page:number){
    let datos: any = {search : '',page :page};
    //console.log("Datos a buscar");
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.consultarUusuario+productoId, datos);
  }

  getUsuariosFilter(productoId, page:number, search:string){

    let datos: any = {search : search,page :page};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.consultarUusuario+productoId, datos);
  }

  getEstatus(idSurvey,surveyKey,empresaId){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.statussurvey + idSurvey+'/'+surveyKey+'/'+empresaId);
  }
  getEstatusNorma(idSurvey1,idSurvey2,surveyKey,empresaId){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.statussurveyNorma + idSurvey1+'/'+idSurvey2+'/'+surveyKey+'/'+empresaId);
  }

  desColaboradores(idSurvey1,idSurvey2,bandera,instituto){
    let datos: any = {bandera : bandera, instituto :instituto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.downloadCol + idSurvey1+'/'+idSurvey2, datos);
  }

  desColaboradoresV2(idSurvey1,idSurvey2,bandera,instituto,nombre){

    let datos: any = {bandera : bandera};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.status_survey_getcolaboradores + idSurvey1+'/'+idSurvey2+'/'+nombre, datos);
  }

  getCatalogos(numInstituto:any, idioma:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.getCatalogos + numInstituto + "/" + idioma);
  }

  saveColaboradorNuevo(idEmpresa:string, idProducto:string, datos:any){
    // console.log("datos:",idEmpresa,idProducto,datos
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.save + idEmpresa + '/' + idProducto, datos);
  }
  //SERVICIO PARA USAR EN EL ADMIN DE FOCUS
  saveColaboradorNuevoFocus(idEmpresa:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.save_fa + idEmpresa, datos);
  }
  buscaOwnkey(idProducto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscaOwnkey + idProducto, datos);
  }
  buscaBossKey(idProducto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscaBossKey + idProducto, datos);
  }
  buscarSurveyKey(idProducto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscarSurveyKey + idProducto, datos);
  }
  buscarEmail(idProducto:string, email:string, paramExtra:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscaEmail + idProducto + "/" + email + "/" + paramExtra);
  }
  getColaboradorFstStp(correo:string, productoId:string){
    let datos: any = {search : correo,page :1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.consultarUusuario+productoId, datos);
  }
  getColaborador(idColaborador:string, idSurvey:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.getSetDelColaborador + idColaborador + "/" + idSurvey);
  }
  deleteColaborador(idColaborador:string, idSurvey:string){
    return this.http.delete(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.getSetDelColaborador + idColaborador + "/" + idSurvey, {});
  }
  updateColaborador(idColaborador:string, idSurvey:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.getSetDelColaborador + idColaborador + "/" + idSurvey, datos);
  }
  //SERVICIO PARA USAR EN EL ADMIN DE FOCUS
  updateColaboradorFocus(idColaborador:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.update_fa + idColaborador, datos);
  }

  sendInv(){
    //return this.http.get(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.getCatalogos + numInstituto);
  }
  sendReminder(){
    //return this.http.get(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.getCatalogos + numInstituto);
  }

  saveActualizarFechaCierre(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.fechaCierre.saveFechaProrroga ,datos);
  }

  getProrrogasFechaCierre(datos:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.fechaCierre.getProrrogasFechaEncuesta+datos);
  }

  actualizaEstatusCierreEncuesta(empresaId:any,productoId:any,datos:any){
    console.log('empresaId',empresaId);
    console.log('productoId',productoId);
    console.log('datos',datos);

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.fechaCierre.cerrarEncuesta+empresaId+'/'+productoId,datos);
  }

  cierreEncuestaStatus2(token: string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.fechaCierre.surveyClose + token, {});
  }

  getEstatusCierreEncuesta(datos:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.fechaCierre.getStatusEncuesta+datos);
  }

  send_email(datos:any, idEmpresa:any, idProducto:any){
    console.log(DATOS_API.url + DATOS_API.endpoints.send_email+idEmpresa+'/'+idProducto);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.send_email+idEmpresa+'/'+idProducto,datos);
  }
  send_emailfocus(datos:any, idEmpresa:any, idProducto:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.send_emailfocus+idEmpresa+'/'+idProducto,datos);
  }

  send_emailnorma(datos:any, idEmpresa:any, idProducto:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.send_emailnorma+idEmpresa+'/'+idProducto,datos);
  }

  sincronizarConteos(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.sincronizar,datos);
  }

  getColaboradoresFullFocusArea(datos,idEncuesta){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getInfoColaboradoresFull + idEncuesta, datos);
  }

  getMostrarEncuestas(data,idEmpresa){
    console.log(data);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getEncuestas+idEmpresa,data);
  }

  getMostrarEncuestasFocus(data){
    console.log(data);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getEncuestas+this.idEmpresa,data);
  }

  delete_surveyAnswer(idColaborador,instituto,data){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.delete_answer+idColaborador+'/'+instituto,data);
  }

  getFechaLanzamiento35(data,idEmpresa){
    console.log("Data fecha lanzamiento");
    console.log(data);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.shedule.getFechaLanzamiento+idEmpresa,data);
  }

  getTotalColaboradores(data){

    return this.http.post('https://surveyapi01.culturalgo.com/api/progress/1593732298064',data,
    { headers: new HttpHeaders({'Token': '2f9RkB4P4grmmFd'})});


  }
  getTotalColaboradores_encuesta(idSurvey,instituto){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getCol_survey+idSurvey+'/'+instituto);
  }

  public getPilotoData_medir(data,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.envioCorreo.getPilotoData+idEmpresa,data);
  }

  public getPilotoData_Pulse(data,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getEncuetasPulsePiloto+idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/getPiloto/'+this.getCompanyID(),data,
    //   { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getAvanceEncuestaMedir(data,idEmpresa){

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.cierre.getAvanceEncuesta+idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/getAvanceEncuesta/'+this.getCompanyID(),data,
    //{ headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  informacion_template(idEmpresa,data){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.empresaTemplate+idEmpresa,data);
  }

  getAvanceEncuestaFocus(idEncuesta){
    let data=" ";

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getAvanceEncuestaFocusArea+idEncuesta,data);
    // return this.httpClient.post(this.ip+'/api_empresa/getAvanceEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  actualizarFechadeCierre(data,idEncuesta?){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateEndDate,data);
  }

  Normaclosesurvey(productoId,typesurvey,idEmpresa){
    let datos: any = { productoId: productoId, tipoEncuesta:typesurvey};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getsurveyclose + idEmpresa, datos);
  }

  getInfoColabarador(productoId,nombre,email){
    let datos: any = { productoId: productoId, tipoEncuesta:nombre};
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.getinfoxColabarador+productoId+'/'+ nombre+'/'+email);
  }
  getInfoColabaradorPorPassword(productoId,password){
    // let datos: any = { productoId: productoId, tipoEncuesta:nombre};
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscarColaboradorPassword+productoId+'/'+ password);
  }

  getColaboradoresFull(idEmpresa: string, producto: string){
    let datos: any = {productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getColaboradoresFull + idEmpresa, datos);
  }

  cierreManual(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.cierreManual, datos);
  }

}
